import React from 'react';
import { SectionWrapperStyled, SeparatorWrapper } from './styled';
export function IndentWrapper({ children, isRemoveBottomIndent, isRightToLeft = false, dataTestId = 'default', id, }) {
    return (React.createElement(SectionWrapperStyled, { id: id, isRightToLeft: isRightToLeft, "data-test-id": `wrapper-component-${dataTestId}` },
        children,
        !isRemoveBottomIndent && React.createElement(SeparatorWrapper, null)));
}
